import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-black text-white pt-16 pb-24 px-4 border-b-4 border-neon" data-id="element-216">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-217">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-8 font-montserrat tracking-tight" data-id="element-218">
          "Descubre el Método que Personas Normales en España Están Usando para
          Ganar 500€ Extra al Mes..."
        </h1>

        <div className="w-full max-w-3xl mx-auto mb-8 relative group cursor-pointer" onClick={() => document.getElementById('compra')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-219">
          <div className="absolute inset-0 bg-neon opacity-20 blur-2xl rounded-full group-hover:opacity-40 transition-opacity duration-500" data-id="element-220"></div>
          <img src="https://cdn.magicpatterns.com/uploads/bdih42FJdYugB6t1T9BLSt/mockup.png" alt="El Método 500€ Producto Completo" width={1400} height={768} fetchPriority="high" decoding="async" className="w-full h-auto relative z-10 drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-221" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-neon mb-10 leading-snug" data-id="element-222">
          ...Con Solo un Móvil, Sin Seguidores y Sin Invertir un Solo Euro
        </h2>

        <div className="max-w-2xl mx-auto text-gray-300 text-lg md:text-xl leading-relaxed mb-12 space-y-6" data-id="element-223">
          <p className="italic font-medium text-white" data-id="element-224">
            Sí, lo que estás leyendo es real.
          </p>
          <p data-id="element-225">
            Ahora mismo, más de 12.000 marcas españolas están buscando
            desesperadamente personas normales que graben videos cortos con el
            móvil para sus anuncios en TikTok e Instagram.
          </p>
          <p data-id="element-226">No necesitan influencers. No necesitan actores.</p>
          <p className="text-white font-bold text-2xl" data-id="element-227">
            Necesitan gente como tú.
          </p>
          <p data-id="element-228">
            Y están pagando entre{' '}
            <span className="text-neon font-bold" data-id="element-229">
              50€ y 300€ por cada video de 30 segundos.
            </span>
          </p>
        </div>

        <CTAButton data-id="element-230" />
      </div>
    </section>;
}